import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    //   mode: "history",
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },
    routes: [
		{
		    path: "/",
		    redirect: {
		        name: "index"
		    }
		},
        {
            path: "/index",
            name: "index",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/index/index.vue")
        },
		{
		    path: "/activity",
		    name: "activity",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/index/activity.vue")
		},
		{
		    path: "/information",
		    name: "information",
		    component: () =>
		        import("./views/index/information.vue")
		},
		{
		    path: "/infoResult",
		    name: "infoResult",
		    component: () =>
		        import("./views/index/infoResult.vue")
		},
		{
		    path: "/infoHonour",
		    name: "infoHonour",
		    component: () =>
		        import("./views/index/infoHonour.vue")
		},
		{
		    path: "/infoDiploma",
		    name: "infoDiploma",
		    component: () =>
		        import("./views/index/infoDiploma.vue")
		},
		{
		    path: "/infoAddress1",
		    name: "infoAddress1",
		    component: () =>
		        import("./views/index/infoAddress1.vue")
		},
		{
		    path: "/infoAddress2",
		    name: "infoAddress2",
		    component: () =>
		        import("./views/index/infoAddress2.vue")
		}
    ]
});
